export const COLOR_CRITICAL = '#C00000';
export const COLOR_HIGH = '#FF0000';
export const COLOR_MEDIUM = '#FF7900';
export const COLOR_LOW = '#FFD200';
export const COLOR_INFO = '#dcf5eb';

export const COLOR_SLA_IN = '#50BE87';
export const COLOR_SLA_RISK = '#FFD200';
export const COLOR_SLA_BREAK = '#FF0000';
